export type AppErrorCode =
  | "UNSUPPORTED_MEDIA"
  | "DECODE_FAILED"
  | "GPU_UNAVAILABLE"
  | "MEMORY_PRESSURE"
  | "INVALID_EFFECT_PARAMETERS"
  | "VECTOR_COMPLEXITY"
  | "EXPORT_FAILED";

export class AppError extends Error {
  readonly code: AppErrorCode;
  override readonly cause?: unknown;

  constructor(code: AppErrorCode, message: string, cause?: unknown) {
    super(message, { cause });
    this.name = "AppError";
    this.code = code;
    this.cause = cause;
  }
}
